var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16602 1.56348H15.166V3.56348H9.16602V1.56348ZM11.166 14.5635V8.56348H13.166V14.5635H11.166ZM19.196 7.95348L20.616 6.53348C20.186 6.02348 19.716 5.54348 19.206 5.12348L17.786 6.54348C16.236 5.30348 14.286 4.56348 12.166 4.56348C7.19602 4.56348 3.16602 8.59348 3.16602 13.5635C3.16602 18.5335 7.18602 22.5635 12.166 22.5635C17.146 22.5635 21.166 18.5335 21.166 13.5635C21.166 11.4435 20.426 9.49348 19.196 7.95348ZM5.16602 13.5635C5.16602 17.4335 8.29602 20.5635 12.166 20.5635C16.036 20.5635 19.166 17.4335 19.166 13.5635C19.166 9.69348 16.036 6.56348 12.166 6.56348C8.29602 6.56348 5.16602 9.69348 5.16602 13.5635Z",
    fill: "currentColor"
  })));
};
export default SvgStopwatch;